/**
 * Repository Fragment - ES6 Module Version
 * Handles repository logs: date filtering, time period selection
 */
import { Events } from '../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Repository Logs Handlers
// ============================================================================

const RepositoryLogsHandlers = {
    /**
     * Update date inputs enabled/disabled state based on time period selection
     */
    updateDateInputs(isSimple) {
        const simpleSelect = document.getElementById('simple-select');
        const startDate = document.getElementById('start-date');
        const endDate = document.getElementById('end-date');

        if (simpleSelect) {
            simpleSelect.disabled = !isSimple;
        }
        if (startDate) {
            startDate.disabled = isSimple;
        }
        if (endDate) {
            endDate.disabled = isSimple;
        }
    },

    /**
     * Handle simple time period radio change
     */
    onSimpleTimePeriodChange(e, element) {
        RepositoryLogsHandlers.updateDateInputs(true);
        // Submit the form
        const form = document.getElementById('logs-form');
        if (form) {
            form.requestSubmit();
        }
    },

    /**
     * Handle custom time period radio change
     */
    onCustomTimePeriodChange(e, element) {
        RepositoryLogsHandlers.updateDateInputs(false);
    },

    /**
     * Handle simple select dropdown change
     */
    onSimpleSelectChange(e, element) {
        // Check the simple radio button
        const simpleRadio = document.getElementById('time-simple');
        if (simpleRadio) {
            simpleRadio.checked = true;
        }
        // Submit the form
        const form = document.getElementById('logs-form');
        if (form) {
            form.requestSubmit();
        }
    },

    /**
     * Handle date input focus - switch to custom mode
     */
    onDateInputFocus(e, element) {
        const customRadio = document.getElementById('time-custom');
        if (customRadio) {
            customRadio.checked = true;
        }
        RepositoryLogsHandlers.updateDateInputs(false);
    },

    /**
     * Handle Go button click - only switch to custom mode if explicitly clicked
     * (not when form is submitted via Enter key in other inputs)
     */
    onGoButtonClick(e, element) {
        // Only switch to custom mode if this was a real mouse/touch click on the button
        // When form submits via Enter key, e.detail is 0 (no click count)
        // When user clicks button, e.detail is 1 or more
        if (e.detail > 0) {
            const customRadio = document.getElementById('time-custom');
            if (customRadio) {
                customRadio.checked = true;
            }
        }
    }
};

/**
 * Initialize repository fragment
 * Called from main.js on DOMContentLoaded
 */
export function initRepository() {
    if (initialized) return;
    initialized = true;

    // Time period radio buttons
    Events.on('change', 'repository-logs-simple-radio', RepositoryLogsHandlers.onSimpleTimePeriodChange);
    Events.on('change', 'repository-logs-custom-radio', RepositoryLogsHandlers.onCustomTimePeriodChange);

    // Simple time period select
    Events.on('change', 'repository-logs-simple-select', RepositoryLogsHandlers.onSimpleSelectChange);

    // Date input focus
    Events.on('focus', 'repository-logs-date-input', RepositoryLogsHandlers.onDateInputFocus);

    // Go button click
    Events.on('click', 'repository-logs-go-button', RepositoryLogsHandlers.onGoButtonClick);
}
